const mUrlsPrecarregadas = new Set()
const mOrigensPreconectadas = new Set()

const INFO_MESSAGE_RESTRICTED = "_INFO_MESSAGE_RESTRICTED_INFO_"
const INFO_MESSAGE_DELETED = "_INFO_MESSAGE_DELETED_INFO_"

const mensagemCitadaMascaradaEh = (oMensagemCitada) =>
  oMensagemCitada?.body === INFO_MESSAGE_RESTRICTED || oMensagemCitada?.body === INFO_MESSAGE_DELETED

const origemObter = (cUrl) => {
  try {
    return new URL(cUrl).origin
  } catch (_err) {
    return null
  }
}

const preconnectCriar = (cUrl) => {
  const cOrigem = origemObter(cUrl)
  if (!cOrigem || mOrigensPreconectadas.has(cOrigem)) return

  mOrigensPreconectadas.add(cOrigem)

  const oPreconnect = document.createElement("link")
  oPreconnect.rel = "preconnect"
  oPreconnect.href = cOrigem
  oPreconnect.crossOrigin = "anonymous"
  document.head.appendChild(oPreconnect)
}

const imagemPrecarregar = (cUrl) => {
  if (!cUrl || mUrlsPrecarregadas.has(cUrl)) return

  mUrlsPrecarregadas.add(cUrl)
  preconnectCriar(cUrl)

  const oImagem = new Image()
  oImagem.decoding = "async"
  if ("fetchPriority" in oImagem) {
    oImagem.fetchPriority = "high"
  }
  oImagem.src = cUrl

  if (typeof oImagem.decode === "function") {
    oImagem.decode().catch(() => {})
  }
}

export const mensagensMidiasPrecarregar = (mMensagens = [], { nMaximoImagens = 4 } = {}) => {
  if (typeof window === "undefined" || typeof document === "undefined") return

  let nImagens = 0
  const mMensagensNovasPrimeiro = [...mMensagens].reverse()

  mMensagensNovasPrimeiro.forEach((oMensagem) => {
    if (!oMensagem) return

    if (oMensagem.mediaUrl && !mensagemCitadaMascaradaEh(oMensagem)) {
      preconnectCriar(oMensagem.mediaUrl)
    }

    if (
      oMensagem.mediaType === "image" &&
      oMensagem.mediaUrl &&
      !mensagemCitadaMascaradaEh(oMensagem) &&
      nImagens < nMaximoImagens
    ) {
      imagemPrecarregar(oMensagem.mediaUrl)
      nImagens += 1
    }

    const oMensagemCitada = oMensagem.quotedMsg
    if (!oMensagemCitada || mensagemCitadaMascaradaEh(oMensagemCitada)) {
      return
    }

    if (oMensagemCitada.mediaUrl) {
      preconnectCriar(oMensagemCitada.mediaUrl)
    }

    if (oMensagemCitada.mediaType === "image" && oMensagemCitada.mediaUrl && nImagens < nMaximoImagens) {
      imagemPrecarregar(oMensagemCitada.mediaUrl)
      nImagens += 1
    }
  })
}
